import * as React from 'react'
import { datadogRum } from '@datadog/browser-rum-slim'

const styles = require('./styles')

interface ErrorBoundaryState {
  hasError: boolean
}
interface ErrorBoundaryProps {
  children: React.ReactNode
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error) {
    datadogRum.addError(error, {
      message: 'Error Captured in Error Boundary',
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.container}>
          <h1>Something went wrong!</h1>
          <h3>We're working on a fix</h3>
          <p>
            Search and compare savings and personal loans with{' '}
            <a href="https://fiona.com" target="_blank">
              Fiona
            </a>
            !
          </p>
        </div>
      )
    }

    return this.props.children
  }
}
